









































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { APP_CONFIG } from '@/config/app-config';
import commonService from '@/services/common-services';
import orderService from '@/services/order-service';
import { Order } from '@/models/order';
@Component
export default class CustomerInfo extends Vue {
    get customerInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].customerInfo;
    }
    @Prop({default: null})
    private order!: Order;

    get warehouse() {
        let tmp = this.$store.state[APP_CONFIG.stateKey.commonStore].warehouse;
        return tmp ? tmp.filter(p => p.StoreType === 1) : null;
    }

    get chinaStore() {
        let tmp = this.$store.state[APP_CONFIG.stateKey.commonStore].chinaStore;
        return tmp ? tmp.filter(p => p.StoreType === 1) : null;
    }

    get safeLevelDesc() {
        if (this.order && this.safeLevels) {
            const result = this.safeLevels.find(c => c.ID == this.order.safeLevelID);
            if (result) {
                return result.Description;
            }
        }
        return '';
    }

    get safeLevels() {
        let tmp = this.$store.state[APP_CONFIG.stateKey.commonStore].safeLevel
        if (tmp != null) {
            tmp.unshift({ID: 0, Name: ''});
        }
        return tmp;
    }

    private async getWarehouse() {
        const result = await commonService.getWarehouse();
        if (result && result.status === 200) {
            (window['getApp'] as any).$emit('SET_WAREHOUSE', result.data.data);
        }
    }

    private async getChinaStore() {
        const result = await commonService.getChinaStore();
        if (result && result.status === 200) {
            (window['getApp'] as any).$emit('SET_CHINASTORE', result.data.data);
        }
    }

    private async getSafeLevel() {
        const result = await commonService.getSafeLevel();
        if (result && result.status === 200) {
            (window['getApp'] as any).$emit('SET_SAFELEVEL', result.data.data);
        }
    }

    private async safeLevelChanged() {
        let payload = {SafeLevelID: this.order.safeLevelID};
        const result = await orderService.updateOrder(this.order.id, payload);
        if (result && result.status === 200 && result.data.status === 200) {
            Vue.notify({
                group: 'foo',
                type: 'success',
                title: 'Thông báo!',
                text: 'Cập nhật đơn hàng thành công!',
            });
        } else if (result && result.data.status === 202) {
            Vue.notify({
                group: 'foo',
                type: 'error',
                title: 'Thông báo!',
                text: result.data.error,
            });
        } else {
            Vue.notify({
                group: 'foo',
                type: 'error',
                title: 'Thông báo!',
                text: 'Có lỗi trong quá trình xử lý dữ liệu!',
            });
        }
    }

    private async created() {
        if (!this.warehouse) {
            await this.getWarehouse();
        }
        if (!this.chinaStore) {
            await this.getChinaStore();
        }
        if (!this.safeLevels) {
            await this.getSafeLevel();
        }
    }
}
